import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
var BackgroundLoader = /*#__PURE__*/function () {
  function BackgroundLoader(loader) {
    var verbose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, BackgroundLoader);
    this._loader = loader;
    this._assetList = [];
    this._isLoading = false;
    this._maxConcurrent = 1;
    this.verbose = verbose;
  }
  _createClass(BackgroundLoader, [{
    key: "add",
    value: function add(assetUrls) {
      var _this = this;
      assetUrls.forEach(function (a) {
        _this._assetList.push(a);
      });
      if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
      if (this._isActive && !this._isLoading) {
        this._next();
      }
    }
  }, {
    key: "_next",
    value: function () {
      var _next2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var toLoad, toLoadAmount, i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this._assetList.length && this._isActive)) {
                _context.next = 9;
                break;
              }
              this._isLoading = true;
              toLoad = [];
              toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
              for (i = 0; i < toLoadAmount; i++) {
                toLoad.push(this._assetList.pop());
              }
              _context.next = 7;
              return this._loader.load(toLoad);
            case 7:
              this._isLoading = false;
              this._next();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _next() {
        return _next2.apply(this, arguments);
      }
      return _next;
    }()
  }, {
    key: "active",
    get: function get() {
      return this._isActive;
    },
    set: function set(value) {
      if (this._isActive === value) return;
      this._isActive = value;
      if (value && !this._isLoading) {
        this._next();
      }
    }
  }]);
  return BackgroundLoader;
}();
export { BackgroundLoader };